import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { AppConfigType, EntitiyType } from "src/types/apps";

import { apiClient } from "../../config/apiClient";
import { API } from "../../config/apiConfig";

export async function getAppConfigRequest(orgId: string, appId: string) {
	return await apiClient
		.get(API.QUERY.ORGANIZATIONS.APPS.CONFIGURATION(orgId, appId))
		.then((res) => res.data);
}

export async function getAppEntitiesListRequest(orgId: string, appId: string) {
	return await apiClient
		.get(API.QUERY.ORGANIZATIONS.APPS.ENTITIES(orgId, appId))
		.then((res) => res.data);
}

export async function getAvailableEntitiesRequest() {
	return await apiClient.get(API.QUERY.ENTITIES).then((res) => res.data);
}

export function useGetAvailableEntitiesRequest() {
	return useQuery<EntitiyType[], AxiosError>({
		queryKey: ["entities"],
		queryFn: () => getAvailableEntitiesRequest()
	});
}

export function useGetAppConfigurationRequest(orgId: string, appId: string) {
	return useQuery<AppConfigType, AxiosError>({
		queryKey: [appId, "config"],
		queryFn: () => getAppConfigRequest(orgId, appId),
		enabled: !!orgId && !!appId && appId !== ""
	});
}

export function useGetAppEntitiesListRequest(orgId: string, appId: string) {
	return useQuery<string[], AxiosError>({
		queryKey: [appId, "entities"],
		queryFn: () => getAppEntitiesListRequest(orgId, appId),
		enabled: !!orgId && !!appId && appId !== ""
	});
}
